import { create } from "zustand";

export enum DRAWER_MODE {
    MINIMIZED,
    MAXIMIZING,
    MINIMIZING,
    MAXIMIZED,
}
interface BottomSheetSlice {
    maximize: () => void;
    ready: boolean;
    setState: (value: DRAWER_MODE) => void;
    shouldMaximize: boolean;
    state: DRAWER_MODE;
    setReady(value: boolean): void;
}

export const useBottomSheetStore = create<BottomSheetSlice>()((set, get) => ({
    shouldMaximize: false,
    state: DRAWER_MODE.MINIMIZED,
    setState: (value: DRAWER_MODE) =>
        set(() => ({
            state: value,
            shouldMaximize:
                value === DRAWER_MODE.MAXIMIZED ? false : get().shouldMaximize,
        })),
    ready: false,
    setReady: (value: boolean) => {
        if (get().ready) {
            return;
        }
        requestAnimationFrame(() => set({ ready: value }));
    },
    maximize: () => set(() => ({ shouldMaximize: true })),
}));
